import React from "react";

import UrlIcon from "../icons/call.svg";

const Contact = () => {
  return (
    <a href="tel:+1 720-414-5030" className="tel-link">
      <img className="url-icon" alt="CallIcon" src={UrlIcon} />
      <h1 className="tel-header"> Call +1 720-414-5030</h1>
    </a>
  );
};

export default Contact;
